import React from 'react';
import useExhibitorSearch from '../ExhibitorsPage/useExhibitorSearch';
import useProductSearch from '../ProductsPage/useProductSearch';
import useEventData from './useEventData';

export default function useSiteSearch({ locale, initialTerm }) {
  const [term, setTerm] = React.useState(initialTerm);
  const all = useEventData();
  const { exhibitors, products } = React.useMemo(
    () => ({
      exhibitors: all.exhibitors.filter((item) => item.locale === locale),
      products: all.products.filter((item) => item.locale === locale),
    }),
    [all.exhibitors, all.products, locale]
  );
  const filteredExhibitors = useExhibitorSearch(exhibitors, term);
  const filteredProducts = useProductSearch(products, term);
  return {
    exhibitors: filteredExhibitors,
    products: filteredProducts,
    term,
    setTerm,
  };
}
